import React, { useContext } from 'react';
import classnames from 'classnames';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import s from './Separator.scss';

export enum Breakpoint {
  Both,
  Desktop,
  Mobile,
}

interface Props {
  className?: string;
  forBreakpoint?: Breakpoint;
}

const Separator: React.FC<Props> = ({
  className,
  forBreakpoint = Breakpoint.Both,
  ...rest
}) => {
  const isMobile = useContext(MobileContext);
  return (
    <hr
      className={classnames(
        className,
        s['separator'],
        forBreakpoint === Breakpoint.Desktop && isMobile && s['hidden'],
        forBreakpoint === Breakpoint.Mobile && !isMobile && s['hidden']
      )}
      {...rest}
    />
  );
};
Separator.displayName = 'Separator';

export default Separator;
